import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';

import { ActivityService } from '../../../_services';
import { FormControl, Validators } from '@angular/forms';
import { ToastyService, ToastOptions } from 'ng2-toasty';
import {Store} from '@ngxs/store';
import {SetPageHeaderTitle} from '../../../core/data-management/actions/projects.action';

@Component({
  selector: 'app-imaging-project-activity',
  templateUrl: './imaging-project-activity.component.html',
  styleUrls: ['./imaging-project-activity.component.css']
})
export class ImagingProjectActivityComponent implements OnInit {
  requiredNameCtrl = new FormControl('', [
    Validators.required
  ]);
  requiredDescriptionCtrl = new FormControl('', [
    Validators.required
  ]);
  toastOptions: ToastOptions = {
    title: "",
    showClose: true,
    timeout: 10000,
    theme: "material",
  };
  displayedColumns: string[] = ['row-num', 'activityName', 'description', 'operations'];
  dataSource: MatTableDataSource<any>;
  activities: any[] = [];
  activity: any = {};
  showTable: boolean = true;
  showActivity: boolean = false;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private activityService: ActivityService,
    private toastyService: ToastyService, private store: Store) { }

  ngOnInit() {
    this.store.dispatch(new SetPageHeaderTitle('Activities'));
    this.activityService.getAll().subscribe(
      (response: any) => {
        if (response.responseCode === 200) {
          this.activities = response.data;
          this.dataSource = new MatTableDataSource(this.activities);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        } else {
          this.toastOptions.title = "ERROR " + response.responseCode;
          this.toastOptions.msg = response.responseMessage;
          this.toastyService.error(this.toastOptions);
        }
      }
    );
  }

  showActivities(element) {
    this.activity = {};
    this.showTable = false;
    this.showActivity = true;
    this.requiredNameCtrl.clearValidators();
    this.requiredDescriptionCtrl.clearValidators();
    if (element) {
      this.activity = {...element};
      this.store.dispatch(new SetPageHeaderTitle('Edit Activity'));
    } else {
      this.store.dispatch(new SetPageHeaderTitle('Create Activity'));
    }
  }

  deleteActivity(element) {
    this.activityService.delete(element.id).subscribe(
      (response: any) => {
        if (response.responseCode === 200) {
          this.activityService.getAll().subscribe(
            (response: any) => {
              if (response.responseCode === 200) {
                this.activities = response.data;
                this.dataSource.data = response.data;
              } else {
                this.toastOptions.title = "ERROR " + response.responseCode;
                this.toastOptions.msg = response.responseMessage;
                this.toastyService.error(this.toastOptions);
              }
            }
          );
          this.toastOptions.title = "";
          this.toastOptions.msg = "Activity successfully deleted.";
          this.toastyService.success(this.toastOptions);
        } else {
          this.toastOptions.title = "ERROR " + response.responseCode;
          this.toastOptions.msg = response.responseMessage;
          this.toastyService.error(this.toastOptions);
        }
      }
    );
  }

  hideActivities() {
    this.showTable = true;
    this.showActivity = false;
  }

  saveActivity() {
    if (this.activity.id) {
      this.activityService.update(this.activity).subscribe(
        (response: any) => {
          if (response.responseCode === 200) {
            this.activityService.getAll().subscribe(
              (response: any) => {
                if (response.responseCode === 200) {
                  this.activities = response.data;
                  this.dataSource.data = response.data;
                  this.toastOptions.title = "";
                  this.toastOptions.msg = "Activity successfully updated";
                  this.toastyService.success(this.toastOptions);
                  this.hideActivities();
                } else {
                  this.toastOptions.title = "ERROR " + response.responseCode;
                  this.toastOptions.msg = response.responseMessage;
                  this.toastyService.error(this.toastOptions);
                }
              }
            );
          } else {
            this.toastOptions.title = "ERROR " + response.responseCode;
            this.toastOptions.msg = response.responseMessage;
            this.toastyService.error(this.toastOptions);
          }
        }
      );
    } else {
      this.activityService.create(this.activity).subscribe(
        (response: any) => {
          if (response.responseCode === 200) {
            this.activityService.getAll().subscribe(
              (response: any) => {
                if (response.responseCode === 200) {
                  this.activities = response.data;
                  this.dataSource.data = response.data;
                  this.toastOptions.title = "";
                  this.toastOptions.msg = "Activity successfully created";
                  this.toastyService.success(this.toastOptions);
                  this.hideActivities();
                } else {
                  this.toastOptions.title = "ERROR " + response.responseCode;
                  this.toastOptions.msg = response.responseMessage;
                  this.toastyService.error(this.toastOptions);
                }
              }
            );
          } else {
            this.toastOptions.title = "ERROR " + response.responseCode;
            this.toastOptions.msg = response.responseMessage;
            this.toastyService.error(this.toastOptions);
          }
        }
      );
    }
  }

  applyFilter(filterValue: string) {
    if (this.dataSource !== undefined) {
      this.dataSource.filter = filterValue.trim().toLowerCase();
      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage();
      }
    }
  }

}
